import { configureStore } from '@reduxjs/toolkit'
import {
    createOidcMiddleware,
    loadUser,
    reducer as oidc
} from '@sdb-develop/learning-redux-oidc-es6';
import { listenerMiddleware } from './listenerMiddleware.js';
import { userManager } from "./auth/userManager.js";
import { registerOidcEvents } from './auth/oidcEvents.js';
import { setUnauthorizedHandler } from '../helpers/http.js';
import composition from './composition/composition.js';
import registration from './registration/registration.js';
import scorm from './scorm/scorm.js';
import elearning from './elearning/elearning.js';
import signalR from './signalR/signalR.js';
import auth, { sessionLost } from './auth/auth.js';
import env from './env/env.js';
import notify from './notify/notify.js';

export const store = configureStore({
    reducer: {
        oidc: oidc,
        composition: composition,
        elearning: elearning,
        scorm: scorm,
        registration: registration,
        signalR: signalR,
        auth: auth,
        env: env,
        notify: notify,
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware({
        thunk: true,
        devTools: true,
        serializableCheck: {
            ignoredTypes: ['redux-oidc/USER_FOUND', 'redux-oidc/SILENT_RENEW_ERROR'],
            ignoredPaths: ['oidc.user']
        }
    }).prepend(
        listenerMiddleware.middleware,
    ).concat([
        createOidcMiddleware(userManager),
    ]),
});

registerOidcEvents(store);
setUnauthorizedHandler(() => store.dispatch(sessionLost()));

loadUser(store, userManager);
